module.exports = __webpack_public_path__ + "img/texturepacker.a1aa30e2.svg";